import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Library.module.scss';
import CreationCard from '../../components/CreationCard/CreationCard';
import Icon from '../../components/Icon/Icon';
import { setTopNavbar } from '../../Reducers/actions/navbarActions';
import { fetchRecentlyPurchased } from '../../Reducers/actions/ordersActions';
import CreationSkeleton from '../../components/CreationCard/CreationSkeleton';

const RecentlyPurchased = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const recentlyPurchased = useSelector(state => (state.orders.recently_purchased || []).map((item) => item));
  const loading = useSelector(state => state.orders.loading_recently_purchased);
  const userId = useSelector(state => state.auth.user?.user_id);

  const handleViewCreation = (creation_id) => {
    navigate(`/creations/${creation_id}`)
  }

  useEffect(() => {
    if (userId && !recentlyPurchased && !loading) {
      dispatch(fetchRecentlyPurchased(10));
    }
  }, [dispatch, userId, recentlyPurchased, loading]);

  useEffect(() => {
    dispatch(setTopNavbar({
      title: 'Recently Purchased',
      showBackArrow: true,
    }))
  }, []);

  if (loading) {
    return [1, 2, 3].map((item) => <CreationSkeleton key={item} />)

  }
  return (
    <div>

      <div className={styles.savedSection}>
        <div className={styles.verticalCardList}>
          {loading ? (
            [1, 2, 3].map((item) => <CreationSkeleton key={item} />)
          ) : (
            recentlyPurchased && recentlyPurchased.length > 0 ? (
              <>
                {recentlyPurchased.map((item) => (
                  <CreationCard
                    key={item.creation?.creation_id}
                    title={item.creation?.title}
                    price={item.order_data.amount}
                    thumbnailUrl={item.creation?.thumbnail_url}
                    category={item.creation?.category}
                    users={item.creator}
                    tags={item.creation?.tags}
                    onClick={() => handleViewCreation(item.creation?.creation_id)}
                    media={"item.media"}
                  />
                ))}
                <div style={{ minHeight: 64 }} />
              </>
            ) : (
              <div className={styles.emptyState}>
                <Icon alias="library_v2" width={40} height={40} color="#d9d9d9" />
                <div className={styles.emptyText}>No recently purchased creations yet.</div>
              </div>
            )
          )}
        </div>
        <div style={{ marginBottom: '32px' }} />
      </div>
    </div>
  );
};

export default RecentlyPurchased; 